import { FunctionComponent, ReactNode } from 'react'
import styled from 'styled-components'
import { Card } from '@/components/common/card/card'
import { H2 } from '@/components/common/typography'
import { useBreakpoint } from '@/hooks/use-breakpoint'

export const COMMON_DESKTOP_CARD_BODY_WIDTH = 400

type RWDCardLayoutProps = {
  cardBodyWidth?: number
  children: ReactNode
}

const RWDCardLayout: FunctionComponent<RWDCardLayoutProps> = ({
  cardBodyWidth,
  children,
}) => {
  const breakpoint = useBreakpoint()
  const isDesktop = breakpoint === 'PC'

  if (isDesktop) {
    return (
      <Card>
        <CardBody $width={cardBodyWidth}>{children}</CardBody>
      </Card>
    )
  }

  return children
}

const CardBody = styled.div<{ $width: number | undefined }>`
  width: ${({ $width }): string => ($width ? `${$width}px` : 'inherit')};
`

export const CommonCardTitle = styled(H2)`
  display: inline-block;
  text-align: center;
  margin-bottom: 0;
`

export const CommonCardDescription = styled.span`
  display: inline-block;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: ${(props): string => props.theme.colors.base.grey.grey2};
`

export default RWDCardLayout
